import { ScrollableList } from '@ps/isp-web-component-library';
import type { EventTypeLink } from '@ps/isp-web-services-types';
import type { IspSportsAlias } from '@ps/web-sports-config';
import { landingPageEventTypeIds } from '@ps/web-sports-config';
import type { EventTypeId } from '@ps/web-sports-enums';
import { generateSportsPath } from '@ps/web-sports-utils';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { SportsLink } from '@swf/sports/components';
import { defaultToMatchesTab } from '@swf/sports/hooks/useUrlMenuItems';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

const getAlias = ({
  eventTypeId,
  isEventTypeLandingPage
}: {
  eventTypeId: EventTypeId;
  isEventTypeLandingPage: boolean;
}): IspSportsAlias => {
  let alias: IspSportsAlias = 'sportsSport';

  if (isEventTypeLandingPage) {
    alias = 'sportsLanding';
  } else if (defaultToMatchesTab.includes(eventTypeId)) {
    alias = 'sportsMatchFiltering';
  }

  return alias;
};

interface Props {
  popularSport: EventTypeLink;
}

export const PopularSportsPickerItem: React.FC<Props> = ({ popularSport }) => {
  const { eventTypeId, eventTypeSlug, text } = popularSport;
  const isEventTypeLandingPage = useSelector((state: RootState) =>
    select.sports.isEventTypeLandingPage(state, { eventTypeId, landingPageEventTypeIds })
  );
  const alias = getAlias({ eventTypeId, isEventTypeLandingPage });

  const icon = getEventTypeIcon(eventTypeId);
  const url = generateSportsPath(alias, {
    ...popularSport
  });

  const sportsLinkValues = {
    eventTypeId,
    eventTypeSlug
  };

  return (
    <ScrollableList.Disc
      as={SportsLink}
      icon={icon}
      alias={alias}
      key={text}
      href={url}
      values={sportsLinkValues}
      aria-label={text}
    />
  );
};
